/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernsIssueDto } from './concernsIssueDto.schema';

export const SaveAllStatusConcernsIssue = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.array(zod.lazy(() => ConcernsIssueDto)).optional()
});

export type SaveAllStatusConcernsIssue = zod.input<typeof SaveAllStatusConcernsIssue>;
export type SaveAllStatusConcernsIssueOutput = zod.output<typeof SaveAllStatusConcernsIssue>;
